import React, { FC, useMemo } from "react";

import Typography from "@material-ui/core/Typography";

import { useFormatMessage } from "@comparaonline/react-intl-hooks";
import { EntityFormatter } from "@comparaonline/ui-offer-entity-formatter";

import { useAppContext } from "../../../../lib/appContext";

interface InsurableValueProps {
  value: number;
}

const InsurableValue: FC<InsurableValueProps> = ({ value }) => {
  const t = useFormatMessage();
  const formatterValue = useMemo(() => ({ amount: value }), [value]);
  const {
    businessUnitConfig: { currencyFormat }
  } = useAppContext();

  return (
    <Typography align="center" color="primary" component="div" variant="subtitle1">
      {t("results.summary.valuation")}
      <EntityFormatter format={currencyFormat} value={formatterValue} type="money" />
    </Typography>
  );
};

export { InsurableValue };
